(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["press-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kindred-press-banner')) {
    customElements.define('kindred-press-banner', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.viewport = this.querySelector('[data-press-viewport]');
        this.marquee = this.querySelector('[data-press-marquee]');
        this.original = this.querySelector('[data-press-original]');
        this.quotes = [...this.querySelectorAll('[data-press-quote]')];
        this.dots = [...this.querySelectorAll('[data-press-dot]')];
        this.motionButton = this.querySelector('[data-press-motion]');
        this.current = 0;
        this.manualPause = false;
        this.hovered = false;
        this.focused = false;
        this.heldBlock = null;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.nearView = false;
        this.marqueeReady = false;
        const controls = this.querySelector('[data-press-controls]');
        if (controls) controls.hidden = false;
        this.motionButton?.addEventListener('click', () => {
          this.manualPause = !this.manualPause;
          this.syncPlayback();
        }, { signal });
        this.querySelector('[data-press-prev]')?.addEventListener('click', () => this.showQuote(this.current - 1), { signal });
        this.querySelector('[data-press-next]')?.addEventListener('click', () => this.showQuote(this.current + 1), { signal });
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.showQuote(index), { signal }));
        this.addEventListener('pointerover', event => {
          if (event.pointerType === 'touch') return;
          this.hovered = !event.target.closest('[data-press-motion]');
          this.syncPlayback();
        }, { signal });
        this.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.syncPlayback();
        }, { signal });
        this.addEventListener('focusin', event => {
          this.focused = !event.target.closest('[data-press-motion]');
          if (this.original?.contains(event.target)) this.revealLogo(event.target.closest('[data-block-id]'));
          this.syncPlayback();
        }, { signal });
        this.addEventListener('focusout', event => {
          this.focused = this.contains(event.relatedTarget) && !event.relatedTarget?.closest('[data-press-motion]');
          this.syncPlayback();
        }, { signal });
        this.querySelector('[data-press-controls]')?.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.showQuote(this.current + (event.key === 'ArrowRight' ? 1 : -1));
        }, { signal });
        document.addEventListener('visibilitychange', () => this.syncPlayback(), { signal });
        this.reducedMotion.addEventListener('change', () => this.scheduleRebuild(), { signal });
        document.addEventListener('shopify:block:select', event => {
          const block = [...this.querySelectorAll('[data-block-id]')].find(item => item.dataset.blockId === event.detail.blockId);
          if (!block) return;
          this.heldBlock = event.detail.blockId;
          const quoteIndex = this.quotes.indexOf(block);
          if (quoteIndex > -1) this.showQuote(quoteIndex);
          else this.revealLogo(block);
          this.syncPlayback();
        }, { signal });
        document.addEventListener('shopify:block:deselect', event => {
          if (this.heldBlock !== event.detail.blockId) return;
          this.heldBlock = null;
          this.syncPlayback();
        }, { signal });
        this.addEventListener('load', event => {
          if (this.original?.contains(event.target)) this.scheduleRebuild();
        }, { signal, capture: true });
        if (this.viewport && this.original) {
          this.observer = new ResizeObserver(() => this.scheduleRebuild());
          this.observer.observe(this.viewport);
          this.observer.observe(this.original);
        }
        this.showQuote(0);
        // Speed fix 23 Sep 2026: build the scrolling copy of the logos (which downloads
        // them) only when the section is within about a screen of view, and pause the
        // movement and quote rotation again when it is further away.
        this.viewObserver = new IntersectionObserver(entries => {
          const near = entries.some(entry => entry.isIntersecting);
          if (near === this.nearView) return;
          this.nearView = near;
          if (near && !this.marqueeReady) {
            this.marqueeReady = true;
            this.rebuildMarquee();
          } else {
            this.syncPlayback();
          }
        }, { rootMargin: '100% 0px' });
        this.viewObserver.observe(this);
        document.fonts?.ready.then(() => { if (!signal.aborted) this.scheduleRebuild(); });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.viewObserver?.disconnect();
        this.animation?.cancel();
        clearTimeout(this.quoteTimer);
        cancelAnimationFrame(this.resizeFrame);
      }

      scheduleRebuild() {
        if (!this.marqueeReady) return;
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = requestAnimationFrame(() => this.rebuildMarquee());
      }

      rebuildMarquee() {
        const oldDuration = this.animation?.effect.getTiming().duration || 1;
        const progress = ((this.animation?.currentTime || 0) % oldDuration) / oldDuration;
        this.animation?.cancel();
        this.animation = null;
        this.querySelectorAll('[data-press-clone]').forEach(clone => clone.remove());
        this.classList.remove('is-moving');
        if (this.viewport && this.original && !this.reducedMotion.matches) {
          const width = this.original.getBoundingClientRect().width;
          const viewportWidth = this.viewport.clientWidth;
          if (width > 0 && viewportWidth > 0) {
            const cloneCount = Math.max(1, Math.ceil(viewportWidth / width));
            for (let index = 0; index < cloneCount; index++) {
              const clone = this.original.cloneNode(true);
              clone.removeAttribute('data-press-original');
              clone.setAttribute('data-press-clone', '');
              clone.setAttribute('aria-hidden', 'true');
              [clone, ...clone.querySelectorAll('*')].forEach(element => {
                [...element.attributes].forEach(attribute => {
                  if (attribute.name === 'id' || attribute.name === 'data-block-id' || attribute.name.startsWith('data-shopify')) element.removeAttribute(attribute.name);
                });
                if (element.matches('a, button, input, select, textarea, [tabindex]')) element.setAttribute('tabindex', '-1');
                // Copies are only built once the section is near view, so loading them
                // straight away no longer affects the first page load.
                if (element.tagName === 'IMG') element.loading = 'eager';
              });
              this.marquee.append(clone);
            }
            const duration = width / (Number(this.dataset.speed) || 30) * 1000;
            this.animation = this.marquee.animate([{ transform: 'translateX(0)' }, { transform: `translateX(-${width}px)` }], { duration, iterations: Infinity, easing: 'linear' });
            this.animation.currentTime = progress * duration;
            this.viewport.scrollLeft = 0;
            this.classList.add('is-moving');
          }
        }
        if (this.heldBlock) {
          const held = [...(this.original?.children || [])].find(block => block.dataset.blockId === this.heldBlock);
          if (held) this.revealLogo(held);
        } else if (this.original?.contains(document.activeElement)) {
          this.revealLogo(document.activeElement.closest('[data-block-id]'));
        }
        this.syncPlayback();
      }

      revealLogo(block) {
        if (!block || !this.original || !this.viewport) return;
        const offset = block.offsetLeft - this.original.offsetLeft;
        if (this.animation) {
          const width = this.original.getBoundingClientRect().width;
          const duration = this.animation.effect.getTiming().duration;
          this.animation.currentTime = Math.max(0, Math.min(width - 1, offset - 24)) / width * duration;
          this.viewport.scrollLeft = 0;
        } else {
          this.viewport.scrollLeft = Math.max(0, offset - 24);
        }
      }

      showQuote(index) {
        if (!this.quotes.length) return;
        this.current = (index + this.quotes.length) % this.quotes.length;
        this.quotes.forEach((quote, quoteIndex) => {
          const active = quoteIndex === this.current;
          quote.classList.toggle('is-active', active);
          quote.setAttribute('aria-hidden', String(!active));
          quote.inert = !active;
        });
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });
        this.syncPlayback();
      }

      syncPlayback() {
        clearTimeout(this.quoteTimer);
        const paused = !this.nearView || this.manualPause || this.hovered || this.focused || this.heldBlock || document.hidden || this.reducedMotion.matches;
        if (this.animation) {
          if (paused) this.animation.pause();
          else this.animation.play();
        }
        if (!paused && this.quotes.length > 1) {
          this.quoteTimer = setTimeout(() => this.showQuote(this.current + 1), Number(this.dataset.interval) || 7000);
        }
        if (this.motionButton) {
          this.motionButton.hidden = this.reducedMotion.matches || (!this.animation && this.quotes.length < 2);
          this.motionButton.setAttribute('aria-label', this.manualPause ? this.dataset.playLabel : this.dataset.pauseLabel);
          this.motionButton.querySelector('[data-press-play-icon]').toggleAttribute('hidden', !this.manualPause);
          this.motionButton.querySelector('[data-press-pause-icon]').toggleAttribute('hidden', this.manualPause);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-new"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kindred-press-new')) {
    customElements.define('kindred-press-new', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.viewport = this.querySelector('[data-press-new-viewport]');
        this.marquee = this.querySelector('[data-press-new-marquee]');
        this.original = this.querySelector('[data-press-new-original]');
        this.quotes = [...this.querySelectorAll('[data-press-new-quote]')];
        this.dots = [...this.querySelectorAll('[data-press-new-dot]')];
        this.current = 0;
        this.quoteFocused = false;
        this.heldBlock = null;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.nearView = false;
        this.marqueeReady = false;
        const controls = this.querySelector('[data-press-new-controls]');
        if (controls) controls.hidden = false;
        this.querySelector('[data-press-new-prev]')?.addEventListener('click', () => this.showQuote(this.current - 1), { signal });
        this.querySelector('[data-press-new-next]')?.addEventListener('click', () => this.showQuote(this.current + 1), { signal });
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.showQuote(index), { signal }));
        this.addEventListener('focusin', event => {
          this.quoteFocused = this.quotes.some(quote => quote.contains(event.target));
          if (this.original?.contains(event.target) && event.target.matches(':focus-visible')) this.revealLogo(event.target.closest('[data-block-id]'));
          this.syncPlayback();
        }, { signal });
        this.addEventListener('focusout', event => {
          this.quoteFocused = this.quotes.some(quote => quote.contains(event.relatedTarget));
          this.syncPlayback();
        }, { signal });
        this.querySelector('[data-press-new-controls]')?.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.showQuote(this.current + (event.key === 'ArrowRight' ? 1 : -1));
        }, { signal });
        document.addEventListener('visibilitychange', () => this.syncPlayback(), { signal });
        this.reducedMotion.addEventListener('change', () => this.scheduleRebuild(), { signal });
        document.addEventListener('shopify:block:select', event => {
          const block = [...this.querySelectorAll('[data-block-id]')].find(item => item.dataset.blockId === event.detail.blockId);
          if (!block) return;
          this.heldBlock = event.detail.blockId;
          const quoteIndex = this.quotes.indexOf(block);
          if (quoteIndex > -1) this.showQuote(quoteIndex);
          else this.revealLogo(block);
          this.syncPlayback();
        }, { signal });
        document.addEventListener('shopify:block:deselect', event => {
          if (this.heldBlock !== event.detail.blockId) return;
          this.heldBlock = null;
          this.syncPlayback();
        }, { signal });
        this.addEventListener('load', event => {
          if (this.original?.contains(event.target)) this.scheduleRebuild();
        }, { signal, capture: true });
        if (this.viewport && this.original) {
          this.observer = new ResizeObserver(() => this.scheduleRebuild());
          this.observer.observe(this.viewport);
          this.observer.observe(this.original);
        }
        this.showQuote(0);
        // Speed fix 23 Sep 2026: build the scrolling copy of the logos (which downloads
        // them) only when the section is within about a screen of view, and pause the
        // movement and quote rotation again when it is further away.
        this.viewObserver = new IntersectionObserver(entries => {
          const near = entries.some(entry => entry.isIntersecting);
          if (near === this.nearView) return;
          this.nearView = near;
          if (near && !this.marqueeReady) {
            this.marqueeReady = true;
            this.rebuildMarquee();
          } else {
            this.syncPlayback();
          }
        }, { rootMargin: '100% 0px' });
        this.viewObserver.observe(this);
        document.fonts?.ready.then(() => { if (!signal.aborted) this.scheduleRebuild(); });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.viewObserver?.disconnect();
        this.animation?.cancel();
        clearTimeout(this.quoteTimer);
        cancelAnimationFrame(this.resizeFrame);
      }

      scheduleRebuild() {
        if (!this.marqueeReady) return;
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = requestAnimationFrame(() => this.rebuildMarquee());
      }

      rebuildMarquee() {
        const oldDuration = this.animation?.effect.getTiming().duration || 1;
        const progress = ((this.animation?.currentTime || 0) % oldDuration) / oldDuration;
        this.animation?.cancel();
        this.animation = null;
        this.querySelectorAll('[data-press-new-clone]').forEach(clone => clone.remove());
        this.classList.remove('is-moving');
        if (this.viewport && this.original && !this.reducedMotion.matches) {
          const width = this.original.getBoundingClientRect().width;
          const viewportWidth = this.viewport.clientWidth;
          if (width > 0 && viewportWidth > 0) {
            const cloneCount = Math.max(1, Math.ceil(viewportWidth / width));
            for (let index = 0; index < cloneCount; index++) {
              const clone = this.original.cloneNode(true);
              clone.removeAttribute('data-press-new-original');
              clone.setAttribute('data-press-new-clone', '');
              clone.setAttribute('aria-hidden', 'true');
              [clone, ...clone.querySelectorAll('*')].forEach(element => {
                [...element.attributes].forEach(attribute => {
                  if (attribute.name === 'id' || attribute.name === 'data-block-id' || attribute.name.startsWith('data-shopify')) element.removeAttribute(attribute.name);
                });
                if (element.matches('a, button, input, select, textarea, [tabindex]')) element.setAttribute('tabindex', '-1');
                // Copies are only built once the section is near view, so loading them
                // straight away no longer affects the first page load.
                if (element.tagName === 'IMG') element.loading = 'eager';
              });
              this.marquee.append(clone);
            }
            const duration = width / (Number(this.dataset.speed) || 30) * 1000;
            this.animation = this.marquee.animate([{ transform: 'translateX(0)' }, { transform: `translateX(-${width}px)` }], { duration, iterations: Infinity, easing: 'linear' });
            this.animation.currentTime = progress * duration;
            this.viewport.scrollLeft = 0;
            this.classList.add('is-moving');
          }
        }
        if (this.heldBlock) {
          const held = [...(this.original?.children || [])].find(block => block.dataset.blockId === this.heldBlock);
          if (held) this.revealLogo(held);
        } else if (this.original?.contains(document.activeElement) && document.activeElement.matches(':focus-visible')) {
          this.revealLogo(document.activeElement.closest('[data-block-id]'));
        }
        this.syncPlayback();
      }

      revealLogo(block) {
        if (!block || !this.original || !this.viewport) return;
        const offset = block.offsetLeft - this.original.offsetLeft;
        if (this.animation) {
          const width = this.original.getBoundingClientRect().width;
          const duration = this.animation.effect.getTiming().duration;
          this.animation.currentTime = Math.max(0, Math.min(width - 1, offset - 24)) / width * duration;
          this.viewport.scrollLeft = 0;
        } else {
          this.viewport.scrollLeft = Math.max(0, offset - 24);
        }
      }

      showQuote(index) {
        if (!this.quotes.length) return;
        this.current = (index + this.quotes.length) % this.quotes.length;
        this.quotes.forEach((quote, quoteIndex) => {
          const active = quoteIndex === this.current;
          quote.classList.toggle('is-active', active);
          quote.setAttribute('aria-hidden', String(!active));
          quote.inert = !active;
        });
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });
        this.syncPlayback();
      }

      syncPlayback() {
        clearTimeout(this.quoteTimer);
        const paused = !this.nearView || document.hidden || this.reducedMotion.matches;
        const logoSelected = this.heldBlock && [...(this.original?.children || [])].some(block => block.dataset.blockId === this.heldBlock);
        const quoteSelected = this.heldBlock && this.quotes.some(quote => quote.dataset.blockId === this.heldBlock);
        if (this.animation) {
          if (paused || logoSelected) this.animation.pause();
          else this.animation.play();
        }
        if (!paused && !quoteSelected && !this.quoteFocused && this.quotes.length > 1) {
          this.quoteTimer = setTimeout(() => this.showQuote(this.current + 1), Number(this.dataset.interval) || 7000);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
